import { BlobProvider } from "@react-pdf/renderer";
import { LossRunReportPdf } from "./LossRunReportPdf";
import { useState } from "react";

function LossRunReportButton({ reportData, handlePrintDate }) {
  /*   All States
   ********************************************* */
  const [showPdf, setShowPdf] = useState(false);

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  // Triggered when user clicks Generate in modal

  return (
    <div className="relative">
      {showPdf ? (
        <BlobProvider document={<LossRunReportPdf reportData={reportData} />}>
          {({ url, blob }) => {
            const isDisabled = !blob;
            return (
              <>
                <a
                  href={isDisabled ? "#" : url}
                  download={`Loss-Run-Report-${new Date().toISOString().slice(0, 10)}.pdf`}
                  className="text-decoration-none text-white btn btn-success btn text-nowrap"
                  onClick={(e) => {
                    if (isDisabled) {
                      e.preventDefault();
                      return;
                    }
                    handlePrintDate(reportData);
                  }}
                >
                  <i className="mdi mdi-download"></i>Download Report
                </a>
                <a
                  href={isDisabled ? "#" : url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-white btn btn-primary btn text-nowrap ms-1"
                  onClick={(e) => {
                    if (isDisabled) e.preventDefault();
                  }}
                >
                  <i className="mdi mdi-eye"></i>View Report
                  {!url && (
                    <div
                      className="spinner-border spinner-border-sm text-white mb-1"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </a>
              </>
            );
          }}
        </BlobProvider>
      ) : (
        <button
          className="btn btn-primary btn-sm text-nowrap"
          onClick={() => {
            setShowPdf(true);
          }}
        >
          <i className="mdi mdi-file-pdf"></i> Generate Report
        </button>
      )}
    </div>
  );
}

export default LossRunReportButton;
